import script from "./AiRecommend.vue?vue&type=script&setup=true&lang=js"
export * from "./AiRecommend.vue?vue&type=script&setup=true&lang=js"

import "./AiRecommend.vue?vue&type=style&index=0&id=21a396f5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21a396f5"]])

export default __exports__